import {
  TilePreviewArt,
  type Color,
  type IconName,
  type TilePreviewVariant,
} from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";

export type TilePreviewSubject = {
  key: string;
  label: string;
  type: string;
  icon: IconName;
};

/**
 * Which gallery mockup a widget preset shows. The art vocabulary is
 * domain-free and lives in the `tile-preview` particle; this map is the domain
 * half — it names our widget types. A preset whose type has no dedicated
 * mockup falls back to its own icon, and the pie/donut/heatmap/treemap keys are
 * matched by name so a custom preset of a generic type still gets its shape.
 */
function resolveVariant(preset: TilePreviewSubject): TilePreviewVariant {
  const key = preset.key.toLowerCase();
  const label = preset.label.toLowerCase();
  const type = preset.type.toLowerCase();

  return type === "metric" || type === "projects-closed"
    ? "metric"
    : type === "dimension-bar" ||
        type === "stage-moves" ||
        type === "stage-throughput"
      ? "bar"
      : type === "series-line"
        ? "line"
        : type === "dimension-battery"
          ? "battery"
          : type === "activity-heatmap"
            ? "heatmap"
            : type === "portfolio-map"
              ? "treemap"
              : type === "entity-list" ||
                  type === "favorites-list" ||
                  type === "team-members"
                ? "list"
                : type === "activity-list" || type === "most-active-users"
                  ? "activity"
                  : type === "note"
                    ? "note"
                    : type === "embed"
                      ? "embed"
                      : type === "type-mix"
                        ? key.includes("pie") || label.includes("pie")
                          ? "pie"
                          : "donut"
                        : key.includes("pie") || label.includes("pie")
                          ? "pie"
                          : key.includes("donut") || label.includes("donut")
                            ? "donut"
                            : key.includes("heatmap") || label.includes("heatmap")
                              ? "heatmap"
                              : key.includes("treemap") || label.includes("treemap")
                                ? "treemap"
                                : "fallback";
}

export function TilePreview({
  preset,
  color,
}: Omittable<{
  preset: TilePreviewSubject;
  color?: Color;
}>) {
  return (
    <TilePreviewArt
      variant={resolveVariant(preset)}
      color={color}
      icon={preset.icon}
      idSeed={preset.key}
    />
  );
}
